import React, { FC, useState, useEffect } from 'react'
import {
  Image,
  isEditorActive,
  Text,
} from '@sitecore-jss/sitecore-jss-react'
import { Waypoint } from 'react-waypoint'
import { HistoryBlockProps } from './types/HistoryBlock.types'
import './HistoryBlock.scss'

const HistoryBlock: FC<HistoryBlockProps> = ({
  description,
  icon,
  image,
  index,
  title,
  year,
  isScrolling,
}) => {
  const [enteredWaypoint, setEnteredWaypoint] = useState(
    isEditorActive() ? true : false
  )

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <div className={'HistoryBlock__wrapper'}>
      {!isScrolling && (
        <Waypoint
          onEnter={() => {
            setEnteredWaypoint(true)
          }}
          bottomOffset={'10%'}
        />
      )}
      {
        <>
          <div
            className={`HistoryBlock__year_bg ${
              enteredWaypoint && 'HistoryBlock__bg_animation'
            }`}
          >
            <Text field={year} tag={'span'} />
          </div>
          <div
            className={`HistoryBlock__content ${
              enteredWaypoint && 'HistoryBlock__content_animation'
            }`}
          >
            {index % 2 === 0 ? (
              <div
                className={
                  'HistoryBlock__general_info HistoryBlock__general_info_alignment'
                }
              >
                <Text
                  field={year}
                  className={'HistoryBlock__title_year'}
                  tag={'div'}
                />
                <Text
                  field={title}
                  className={'HistoryBlock__type'}
                  tag={'div'}
                />
                <Text
                  field={description}
                  className={'HistoryBlock__description'}
                  tag={'div'}
                />
              </div>
            ) : (
              index % 2 > 0 && (
                <div className={'HistoryBlock__image'}>
                  <div
                    className={
                      'HistoryBlock__image_wrapper HistoryBlock__image_wrapper_left'
                    }
                  >
                    <Image loading={'lazy'} field={image} />
                  </div>
                </div>
              )
            )}

            <div className={'HistoryBlock__icon'}>
              <div className={'HistoryBlock__icon_wrapper'}>
                <span>
                  <pfe-icon
                    icon={icon.fields['Icon Css Class'].value}
                    size={'24'}
                    color={'complement'}
                  />
                </span>
              </div>
            </div>

            {index % 2 === 0 ? (
              <div className={'HistoryBlock__image'}>
                <div
                  className={
                    'HistoryBlock__image_wrapper HistoryBlock__image_wrapper_right'
                  }
                >
                  <Image field={image} />
                </div>
              </div>
            ) : (
              <div
                className={'HistoryBlock__general_info'}
                style={{ textAlign: 'left' }}
              >
                <Text
                  field={year}
                  className={'HistoryBlock__title_year'}
                  tag={'div'}
                />
                <Text
                  field={title}
                  className={'HistoryBlock__type'}
                  tag={'div'}
                />
                <Text
                  field={description}
                  className={'HistoryBlock__description'}
                  tag={'div'}
                />
              </div>
            )}
          </div>
        </>
      }
    </div>
  )
}

export default HistoryBlock
